import { Download, Visibility } from "@mui/icons-material";
import { Divider } from "@mui/material";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import FileViewerDialog from "../../../../../components/display/fileViewer/FileViewerDialog";
import { GENERATE_DR_LETTER } from "../../../../../enums/ApiPaths";
import useFileDownload from "../../../../../hooks/useFileDownload";
import useFileViewer from "../../../../../hooks/useFileViewer";
import ActionRow from "../../../../admin/clinic/components/actions/ActionRow";

const DOCTORS_LETTER_FILE_NAME = "doctorsLetter.pdf";

export function canViewDoctorsLetter(appointment) {
  return Boolean(appointment?.treatment);
}

export default function DoctorsLetterActions({ appointment }) {
  const { t } = useTranslation();
  const { downloadDoctorsLetter } = useFileDownload(
    GENERATE_DR_LETTER,
    appointment?.id,
  );
  const {
    viewFile,
    downloadViewerFile,
    closeViewer,
    viewerFile,
    isPathLoading,
  } = useFileViewer();

  if (!canViewDoctorsLetter(appointment)) {
    return null;
  }

  const doctorsLetterPath = `${GENERATE_DR_LETTER}${appointment.id}`;

  return (
    <Fragment>
      <Divider />
      <ActionRow
        justButton
        icon={<Visibility />}
        label={t("ViewDoctorsLetter")}
        description={t("ViewDoctorsLetterDesc")}
        loading={isPathLoading(doctorsLetterPath)}
        onClick={() =>
          viewFile({
            path: doctorsLetterPath,
            name: DOCTORS_LETTER_FILE_NAME,
            mimeType: "application/pdf",
          })
        }
        testId={"appointment.details.view-letter-button"}
      />
      <Divider />
      <ActionRow
        justButton
        icon={<Download />}
        label={t("DownloadDoctorsLetter")}
        description={t("DownloadDoctorsLetterDesc")}
        onClick={() => downloadDoctorsLetter()}
        testId={"appointment.details.download-letter-button"}
      />
      <FileViewerDialog
        file={viewerFile}
        onClose={closeViewer}
        onDownload={downloadViewerFile}
      />
    </Fragment>
  );
}
